import React from 'react';
import PropTypes from 'prop-types';


const CheckboxFilterPropTypes = {
  selected: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]).isRequired,
  filter: PropTypes.object.isRequired,
  updateFilterBy: PropTypes.func.isRequired,
};


/* CheckboxFilter
 * Simple checkbox input for filtering the table data based on a binary option
 */
const CheckboxFilter = ({
  updateFilterBy,
  filter: {
    prop,
    name,
  },
  selected,
}) => {
  const handleFilterByChange = event => {
    updateFilterBy(prop, event.target.checked);
  };

  return (
    <div>
      <label>{name}: </label>
      <input
        type="checkbox"
        checked={selected}
        onChange={handleFilterByChange}
      />
    </div>
  );
};
CheckboxFilter.propTypes = CheckboxFilterPropTypes;

export default CheckboxFilter;
